import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['canvas']
  static values = { moleblock: String }

  connect() {
    this.render()
  }

  get moleblock() {
    if (this.m !== undefined) { return this.m }

    let m;
    if (this.hasMoleblockValue) {
      m = this.moleblockValue;
    } else if (this.element.dataset.chemdoodleData) {
      // this is acomidating the old way of doing things
      // see app/assets/javascripts/shared/chemdoodle.js
      m = this.element.dataset.chemdoodleData;
    }
    this.m = m
    return this.m;
  }

  buildCanvas() {
    let id = Math.floor(Math.random() * 1000000);
    this.canvasId = `chemdoodle_render_${id}`
    let canvasElement = document.createElement('canvas');
    canvasElement.id = this.canvasId;
    canvasElement.dataset.chemimagerTarget = "canvas"
    this.element.appendChild(canvasElement);
  }

  render() {
    if (this.moleblock === undefined || this.moleblock === '') { return }

    // Clear any existing canvas elements
    if (this.hasCanvasTarget) {
      this.canvasTarget.remove();
    }
    
    var molecule = ChemDoodle.readMOL(this.moleblock);
    this.buildCanvas()

    let viewACS = new ChemDoodle.ViewerCanvas(this.canvasTarget.id, 150, 150);
    viewACS.styles.bonds_width_2D = .6;
    viewACS.styles.bonds_saturationWidthAbs_2D = 2.6;
    viewACS.styles.bonds_hashSpacing_2D = 2.5;
    viewACS.styles.atoms_font_size_2D = 10;
    viewACS.styles.atoms_font_families_2D = ['Helvetica', 'Arial', 'sans-serif'];
    viewACS.styles.atoms_displayTerminalCarbonLabels_2D = true;
    viewACS.loadMolecule(molecule);
  }
}
